<template>
  <div class="w-full p-4">
    <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
      <button
        type="button"
        class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        @click="close"
      >
        <span class="sr-only">Close</span>
        <!-- Heroicon name: outline/x -->
        <svg
          class="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
    <div class="sm:flex sm:items-start">
      <div class="mt-3 text-center sm:mt-0 sm:text-left">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Add new client
        </h3>
      </div>
    </div>
    <div class="my-8 w-full flex flex-col space-y-4">
      <div>
        <label
          for="name"
          class="block text-sm font-medium text-gray-700"
        >Client Name</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
            id="name"
            ref="NameInput"
            v-model="form.name"
            type="text"
            name="name"
            class="block w-full pr-10 sm:text-sm rounded-md"
            :class="{'focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300': form.errors.name, 'focus:ring-indigo-200 focus:border-indigo-300 border-gray-300': !form.errors.name}"
            placeholder="Client, Inc"
            aria-invalid="true"
            aria-describedby="name-error"
            @change="reset"
          >
          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <!-- Heroicon name: solid/exclamation-circle -->
            <svg
              v-if="form.errors.name"
              class="h-5 w-5 text-red-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <p
          v-if="form.errors.name"
          id="email-error"
          class="mt-2 text-sm text-red-600"
        >
          {{ form.errors.name }}
        </p>
      </div>
      <div>
        <label
          for="name"
          class="block text-sm font-medium text-gray-700"
        >Key Account Manager</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <select
            id="kam"
            v-model="form.key_account_manager"
            class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md focus:ring-indigo-200 focus:border-indigo-300 border-gray-300"
          >
            <option
              v-for="option in team_members"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <button
        type="button"
        class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
        @click="save"
      >
        Add
      </button>
      <button
        type="button"
        class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
        @click="close"
      >
        Cancel
      </button>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      team_members: [],
      form: this.$inertia.form({
        name: '',
        key_account_manager: this.$page.props.user.id,
      }),
    };
  },
    mounted() {
        setTimeout(() => {
            this.$refs.NameInput.focus()
        }, 50)
    },
    created() {
    this.team_members.push({ value: this.$page.props.team.owner.id, text: this.$page.props.team.owner.name });
    for (let i = 0; i < this.$page.props.team.users.length; i++) {
      this.team_members.push({ value: this.$page.props.team.users[i].id, text: this.$page.props.team.users[i].name });
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.form.post(route('clients.store'), {
        errorBag: 'storeClient',
        preserveScroll: true,
      });
    },
    reset() {
      this.form.errors = {};
    },
  },
};
</script>
